import apiService from 'frontcore/data/api-service/api-service'
import { NeilaConfiguration } from 'frontcore/domain/neila/types'

export class NeilaConfigurationAPIServiceError extends Error {}

type NeilaConfigurationAPIResponse = {
  NEILA: {
    ENABLED: boolean
    IMPROVEMENT_IDEAS: {
      QUERY_AGENT: boolean
    }
    PROBLEM_SOLVING: {
      ACTION_PLAN_COPILOT: boolean
    }
    VISUAL_STANDARD: {
      CREATE_DRAFT_COPILOT: boolean
    }
  }
}

const decodeNeilaConfiguration = (data: NeilaConfigurationAPIResponse): NeilaConfiguration => {
  return {
    enabled: data.NEILA.ENABLED,
    improvementIdeas: {
      queryAgent: data.NEILA.IMPROVEMENT_IDEAS.QUERY_AGENT,
    },
    problemSolving: {
      actionPlanCopilot: data.NEILA.PROBLEM_SOLVING.ACTION_PLAN_COPILOT,
    },
    visualStandard: {
      createDraftCopilot: data.NEILA.VISUAL_STANDARD.CREATE_DRAFT_COPILOT,
    },
  }
}

export class NeilaConfigurationAPIService {
  async fetchNeilaConfiguration (): Promise<NeilaConfiguration> {
    try {
      const request = apiService
        .buildRequest()
        .withSessionToken()
        .get<NeilaConfigurationAPIResponse>('configurations/neila/')

      const response = await request
      return decodeNeilaConfiguration(response.data)
    } catch (error: unknown) {
      if (error instanceof Error) {
        throw new NeilaConfigurationAPIServiceError(error.message)
      }
      throw error
    }
  }
}

export default NeilaConfigurationAPIService
